module.exports = __webpack_public_path__ + "6d50b7d6ab048fb2695c6a86f9aef552.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/bunny-ears.png
// module id = 2653
// module chunks = 0